export const USD_DECIMAL = 6;
export const DEFAULT_GAS_LIMIT = 500000;
export const MIN_AMPLIFY = 1.01;
